import { render, staticRenderFns } from "./ScreenRecord.vue?vue&type=template&id=79e1dd96&scoped=true&"
import script from "./ScreenRecord.vue?vue&type=script&lang=js&"
export * from "./ScreenRecord.vue?vue&type=script&lang=js&"
import style0 from "./ScreenRecord.vue?vue&type=style&index=0&id=79e1dd96&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e1dd96",
  null
  
)

export default component.exports